import { render, staticRenderFns } from "./FancySwitch.vue?vue&type=template&id=4b20bf4d&scoped=true&"
import script from "./FancySwitch.vue?vue&type=script&lang=js&"
export * from "./FancySwitch.vue?vue&type=script&lang=js&"
import style0 from "./FancySwitch.vue?vue&type=style&index=0&id=4b20bf4d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b20bf4d",
  null
  
)

export default component.exports